module.exports = __webpack_public_path__ + "static/media/logo.b8039151.webp";